import React from 'react';
import { SvgIcon } from 'core/icons';

const BodyIcon = ({ cabSize, className }) => {
  if (!cabSize) {
    return null;
  }

  const icon = `cab_size_${cabSize}`.replace(/_/g, '-').toLowerCase();
  const iconClassName = 'cab-size';

  return (
    <div className={className}>
      <SvgIcon name={icon} className={iconClassName} />
    </div>
  );
};

export default BodyIcon;
